import PropTypes from "prop-types";
import React from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { createSelector } from 'reselect';

import { Link, useLocation } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { userForgetPassword } from "../../store/actions";

// import images
import profile from "../../assets/images/bg.png";
import logo from "../../assets/images/logo-sm.png";
import mmwtLogo from "../../assets/images/MMWT_logo.jpeg";


const ForgetPasswordPage = props => {
  const dispatch = useDispatch();
  const location = useLocation();
  document.title = "Forget Password | Moeen Memorial";

  // Get pre-filled email from state (if coming from registration flow)
  const stateData = location.state || {};
  const prefilledEmail = stateData.email || "";

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: prefilledEmail,
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
    }),
    onSubmit: (values) => {
      dispatch(userForgetPassword(values, props.router.navigate));
    }
  });

  const forgetpass = createSelector(
    (state ) => state.forgetPassword,
    (layout) => ({
        forgetSuccessMsg: layout.forgetSuccessMsg,
    })
  );
// Inside your component
const { forgetSuccessMsg, forgetError } = useSelector(forgetpass);

  return (
    <div className="bg-pattern" style={{minHeight:"100vh"}}>
      <div className="bg-overlay"></div>
      <div className="account-pages">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-primary-subtle">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Reset Password</h5>
                        <p>Enter your registered email to receive password reset instructions.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={mmwtLogo} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  {/* <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={mmwtLogo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div> */}
                  <div className="p-2">
                    {forgetError && forgetError ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {forgetError}
                      </Alert>
                    ) : null}
                    {forgetSuccessMsg ? (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        <div>
                          <strong>Reset email sent successfully!</strong>
                          <div className="mt-2">
                            {forgetSuccessMsg}
                          </div>
                          <div className="mt-3">
                            <div className="alert alert-info mb-0" role="alert">
                              <h6 className="mb-2">📧 Important Instructions:</h6>
                              <ul className="mb-0" style={{ fontSize: '14px' }}>
                                <li><strong>Check your inbox</strong> for an email from us</li>
                                <li><strong>Check your spam/junk folder</strong> if you don't see it in inbox</li>
                                <li>The reset link will expire in 24 hours</li>
                                <li>If you don't receive the email, you can try again</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </Alert>
                    ) : null}

                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-3">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter your registered email address"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email ? true : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid"><div>{validation.errors.email}</div></FormFeedback>
                        ) : null}
                      </div>

                      {/* Information box - always visible */}
                      <div className="alert alert-info mb-3" role="alert">
                        <div style={{ fontSize: '14px' }}>
                          <strong>📧 After clicking Reset:</strong>
                          <ul className="mb-0 mt-1">
                            <li>Check your <strong>inbox</strong> for the reset email</li>
                            <li>If not found, check your <strong>spam/junk folder</strong></li>
                            <li>Click the link in the email to reset your password</li>
                          </ul>
                        </div>
                      </div>

                      <Row className="mb-3">
                        <Col className="text-end">
                          <button
                            className="btn btn-primary w-md "
                            type="submit"
                          >
                            Send Reset Email
                          </button>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Go back to{" "}
                  <Link to="/login" className="font-weight-medium text-primary">
                    Login
                  </Link>{" "}
                </p>
                <p>
                  © {new Date().getFullYear()} OpEazy.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
